import { SeoCustomData, MatchCommentsComment } from 'appsync';
import { IMatchComment } from '@sky-it-livedata/livedata-sports-design-system';

export const toOptionalString = (value?: string | null): string | undefined => value ?? undefined;

export const toRichString = (value?: SeoCustomData | null): { seoName: string; customName: string } => ({
  seoName: value?.seoName ?? '',
  customName: value?.customName ?? '',
});

export const toComment = (value?: MatchCommentsComment | null): IMatchComment | undefined => {
  if (!value) {
    return undefined;
  }

  return {
    commentId: value.commentId ?? '',
    createdAt: value.createdAt ?? '',
    message: toOptionalString(value.message),
    time: value.time ?? '',
    type: (value.type ?? 'start') as IMatchComment['type'],
    updatedAt: value.updatedAt ?? '',
  };
};

export type MatchStatusType =
  | 'PreMatch'
  | 'Live'
  | 'FirstHalf'
  | 'HalfTime'
  | 'SecondHalf'
  | 'FullTime'
  | 'FullTime90'
  | 'ExtraFirstHalf'
  | 'ExtraHalfTime'
  | 'ExtraSecondHalf'
  | 'FullTimeAfterOverTime'
  | 'FullTimePens'
  | 'ShootOut'
  | 'FullTimeAfterShootOut'
  | 'Postponed'
  | 'Abandoned'
  | 'Cancelled';

export const notLiveArray: ReadonlyArray<MatchStatusType> = [
  'Abandoned',
  'Cancelled',
  'FullTime',
  'FullTimeAfterOverTime',
  'FullTimeAfterShootOut',
  'Postponed',
  'PreMatch',
];

export const isLive = (status: MatchStatusType): boolean => !notLiveArray.includes(status);